export default __webpack_public_path__ + "static/media/eduqasenglish.c19d261c.png";